var _path, _path2, _rect, _rect2, _rect3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeedAproval(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.705673 25.4596C1.06636 24.1611 2.24984 23.2581 3.59746 23.2581H13.9475C15.3415 23.2581 16.5485 24.2263 16.8509 25.5871C17.1261 26.8254 16.1838 28 14.9153 28H2.63129C1.30864 28 0.351675 26.734 0.705673 25.4596Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63477 22.2043C3.17866 20.3314 4.89444 19.043 6.84472 19.043H10.7731C12.6735 19.043 14.323 20.3532 14.7531 22.2043H2.63477Z",
    fill: "#A3A3A3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.10742,
    y: 10.022,
    width: 2.48387,
    height: 9.93549,
    rx: 1,
    transform: "rotate(-49.1605 9.10742 10.022)",
    fill: "#A3A3A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1465,
    y: 1.87915,
    width: 2.48387,
    height: 9.93549,
    rx: 1,
    transform: "rotate(-49.1605 16.1465 1.87915)",
    fill: "#A3A3A3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5254,
    y: 8.59937,
    width: 6.62366,
    height: 6.62366,
    transform: "rotate(-49.1605 12.5254 8.59937)",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9518 12.7461C27.7572 16.0354 31.1373 18.3603 30.0673 19.5982C28.9974 20.836 26.2075 17.8282 22.4021 14.5389C18.5968 11.2496 16.2868 7.68656 16.2868 7.68656C16.2868 7.68656 20.1465 9.45676 23.9518 12.7461Z",
    fill: "#A3A3A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedAproval);
export default __webpack_public_path__ + "static/media/need-aproval.765269e1c42ffbaa9a4aa3d408b42453.svg";
export { ForwardRef as ReactComponent };